import { Component } from "react";
import SliderButtonn from '../../components/layout/SliderButton';

class HeaderMenu extends Component {

    render() {

        const { handleToogleSideBar } = this.props;
        return (
            <div className="w-full text-text">
                {/* <div id="titleBrand" className="hideSideEl flex-none w-60 flex flex-row items-center">
                </div> */}

                <div className="flex-1 pl-3 flex flex-row flex-wrap items-center ml-2 ">
                    <div className="md:flex md:justify-evenly">
                        <SliderButtonn handleToogleSideBar={handleToogleSideBar} />
                    </div>
                </div>
            </div>
        )
    }
}

export default HeaderMenu;